/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import { navigate } from '@reach/router'
import serverData from 'ppbl/utils/server-data'
import { isEmpty } from 'lodash-es'
import clientLogger from 'ppbl/utils/client-logger'
import { UTM_CAMPAIGN } from 'ppbl/utils/constants'
import { trackPage } from 'ppbl/utils/fpti-helper'

/**
 * This is a functional component that handles campaign redirection of users
 * @returns {JSX.Element} - A JSX element
 */
const PPBLCampaignRedirectionHelper = () => {
  const serverSideData = serverData.data

  const baseUri = serverSideData?.baseUri
  const queryParamsString = serverSideData?.ppblUrlQueryParams

  const utmCampaignId = sessionStorage.getItem(UTM_CAMPAIGN)

  useEffect(() => {
    let redirectUri = `${baseUri}/us/paypal/start`

    if (!isEmpty(queryParamsString)) {
      redirectUri += `?${queryParamsString}`
    }

    const logDetails = `Redirecting to start route. Campaign id: ${utmCampaignId}`
    clientLogger.info(logDetails)
    const fptiData = {
      page: 'PPBLCampaignRedirectionHelper',
      pageDetails: logDetails,
    }
    trackPage(fptiData)

    navigate(redirectUri)
  }, [])

  return <></>
}

export default PPBLCampaignRedirectionHelper
